// By default Swiper exports only core version without additional modules (like Navigation, Pagination, etc.). So you need to import and configure them:
import { Swiper, EffectFade, Navigation, Pagination, Autoplay } from 'swiper';
// Swiper.use([EffectFade, Navigation, Pagination, Autoplay]);
// Import Lazyload for looped sliders to avoid image jumping
import { lazyLoadInstance } from '../libs/lazyLoad';

const testimonialsSliderHlds = document.querySelectorAll('.js-testimonials-slider-section');

if (testimonialsSliderHlds) {
	testimonialsSliderHlds.forEach(sliderHld => {
		const sliderEl = sliderHld.querySelector('.js-testimonials-slider');
		const slider = new Swiper(sliderEl, {
			modules: [EffectFade, Navigation, Pagination, Autoplay],
			slidesPerView: 2,
			spaceBetween: 88,
			loop: false,
			grabCursor: true,
			navigation: {
				prevEl: sliderHld.querySelector('.js-swiper-prev'),
				nextEl: sliderHld.querySelector('.js-swiper-next'),
			},
			on: {
				slideChange: function() {
					lazyLoadInstance.update();
				},
			},
			breakpoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 24,
				},
				768: {
					slidesPerView: 2,
				},
				1024: {
					spaceBetween: 88,
				},
			},
		});
		slider;
	});


	const alignSlider = () => {
		const windowWidth = window.innerWidth;

		if (windowWidth <= 1023) return;

		const applyAlignment = (section, isRtl) => {
			const title = section.querySelector('.js-slider-title');
			const titleleftSpace = title.getBoundingClientRect().left;
			const testimonialsSlider = section.querySelector('.js-testimonials-slider-hld');
			testimonialsSlider.style[isRtl ? 'marginRight' : 'marginLeft'] = `${titleleftSpace}px`;
		};

		const isRtl = document.body.classList.contains('rtl');
		testimonialsSliderHlds.forEach(section => applyAlignment(section, isRtl));
	};

	// Initial invocation and setting up the event listener
	if (document.querySelector('.js-slider-title')) {
		alignSlider();
		window.addEventListener('resize', () => alignSlider());
	}
}
const mostRecentSlidersHlds = document.querySelectorAll('.js-slider-most-recent');

if (mostRecentSlidersHlds) {
	mostRecentSlidersHlds.forEach(sliderEl => {
		const slider = new Swiper(sliderEl, {
			modules: [Navigation],
			slidesPerView: 1,
			spaceBetween: 24,
			loop: false,
			grabCursor: true,
			navigation: {
				prevEl: sliderEl.querySelector('.js-slider-most-recent-prev'),
				nextEl: sliderEl.querySelector('.js-slider-most-recent-next'),
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
			on: {
				slideChange: function() {
					lazyLoadInstance.update();
				},
			},
		});
		slider;
	});
}

// const sliderGalleryHolders = document.querySelectorAll('.js-modal-media-gallery-swiper-new');

// if (sliderGalleryHolders.length) {
// 	sliderGalleryHolders.forEach((sliderGalleryHld, index) => {
// 		const sliderGallery = new Swiper(sliderGalleryHld, {
// 			modules: [Navigation, Pagination],
// 			slidesPerView: 1,
// 			loop: false,
// 			grabCursor: true,
// 			navigation: {
// 				prevEl: `.js-modal-media-gallery-swiper-new-prev`,
// 				nextEl: `.js-modal-media-gallery-swiper-new-next`,
// 			},
// 			pagination: {
// 				el: `.js-modal-media-gallery-swiper-new-pagination`,
// 				type: 'fraction',
// 			},
// 			breakpoints: {
// 				1024: {
// 					allowTouchMove: false,
// 				},
// 			},
// 			on: {
// 				slideChange: function() {
// 					lazyLoadInstance.update();
// 				},
// 			},
// 		});
// 		sliderGallery;
// 	});
// }
